import {Route, Routes } from "@angular/router";
import {listerPagePaths} from "@routing/lister-page-paths";
import {dashboardPagePaths} from "@routing/dashboard-page-paths";

export function createEntityDataRedirectRoute(forPath: string, redirectTo: string): Route {
  return {
    path: forPath,
    redirectTo: redirectTo
  }
}

export function createListerPageRedirectRoutes(): Routes {
  return listerPagePaths.map(x => createEntityDataRedirectRoute(x, `entity-data/${x}`));
}

export function createDashboardPageRedirectRoutes(): Routes {
  return dashboardPagePaths.map(x => createEntityDataRedirectRoute(x, `entity-data/${x}`));
}

export const entityDataRedirectRoutes: Routes = [
  ...createListerPageRedirectRoutes(),
  ...createDashboardPageRedirectRoutes()
]
